import { Nullable } from "@/api/ApiClient";
import { WithReferenceCode } from "./ReferenceCodeType";

export type ProviderInvoiceFormData = WithReferenceCode<Nullable<{
    id: string | undefined,
    tipo: string,
    respuesta: string,
    fecha: string,
    pagada: boolean,
    numero: string,
    subtotal: number,
    impuestos: number,
    descuento: number,
    total: number,
    sequence: string,
    document_key: string,
    exchange_rate: number,
    status: string,
    providerId: string,
    provider: any,
    providerInvoiceCategoryId: string,
    providerInvoiceCategory: any,
    currencyId: string,
    currency: any,
    providerNotes: any[],
    providerInvoicePayments: any[],
    providerRecibeId: string,
    providerRecibe: any,
    user: string,
}>>;

export interface ProviderInvoiceCalcultedInputBase {
    hasNotes: boolean,
    hasPayments: boolean
}

export type WithProviderInvoiceCalculateFields<T extends object> = T & ProviderInvoiceCalcultedInputBase;

export const ProviderInvoiceRelatedAttributes: Array<keyof ProviderInvoiceFormData> = ["provider", "providerInvoiceCategory", "currency", "providerNotes", "providerInvoicePayments", "providerRecibe"];